import {VALIDATE_OTP_START, VALIDATE_OTP_SUCCESS, VALIDATE_OTP_FAIL, VALIDATE_OTP_RESET} from './constants';
import {ValidateOtpActions, ValidateOtpState} from './types';

const initialState: ValidateOtpState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: ValidateOtpActions,
): ValidateOtpState => {
  switch (action.type) {
    case VALIDATE_OTP_START:
      return {
        ...initialState,
        loading: true,
      };
    case VALIDATE_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case VALIDATE_OTP_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case VALIDATE_OTP_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
